import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "coomflona_token";
export const USER_KEY = "coomflona_user";

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Active operational unit (KM 117 / Cuparí / all) sent on every request
  const u = localStorage.getItem("coomflona_unidade") || "km117";
  config.headers["X-Unidade"] = u;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const fmtDateOnly = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("pt-BR"); } catch { return iso; }
};

export const CATEGORIA_LABEL = {
  EPI: "EPI",
  Alimento: "Alimento",
  Peca_Geral: "Peça Geral",
  Produto_Comunitario: "Prod. Comunitário",
  Produto_Limpeza: "Produto de Limpeza",
  Cuba: "Cuba",
  Outro: "Outro",
};

export const CATEGORIA_OPTS = Object.keys(CATEGORIA_LABEL);

// Rótulos das unidades (empreendimentos COOMFLONA)
export const UNIDADE_LABEL = {
  km117: "KM 117 Anambé",
  cupari: "Rio Cuparí",
  serraria: "Serraria",
  sede: "SEDE — Santarém",
};

export const fmtUnidade = (code) =>
  UNIDADE_LABEL[(code || "").toLowerCase()] || (code ? code.toUpperCase() : "—");

export const REFEICAO_LABEL = {
  cafe_da_manha: "Café da Manhã",
  almoco: "Almoço",
  janta: "Janta",
  lanche: "Lanche",
};

export const ROLE_LABEL = {
  admin: "Administrador",
  almoxarife: "Almoxarife",
  setor: "Setor / Requisição",
  presidencia: "Presidência",
  tesoureiro: "Tesoureiro",
  compras: "Setor de Compras",
};

export const TIPOS_COMBUSTIVEL = ["Gasolina", "Etanol", "Diesel", "Diesel_S10", "Flex", "GNV"];
export const COMBUSTIVEL_LABEL = {
  Gasolina: "Gasolina",
  Etanol: "Etanol",
  Diesel: "Diesel",
  Diesel_S10: "Diesel S10",
  Flex: "Flex",
  GNV: "GNV",
};

export function formatError(detail) {
  if (detail == null) return "Erro";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
